// Copyright (c) 2021 WiseTime. All rights reserved.

import React, { useState } from "react"
import { Trans } from "@lingui/react"
import Dropdown, { Option } from "features/shared/Dropdown"
import { SortDropdownWrapper } from "../styles"

type Props = {
  value: Option["value"],
  options: Option[],
  onChange: (value: Option["value"]) => void,
  isRecentList?: boolean,
}

const SortDropdown = ({
  value,
  options,
  onChange,
  isRecentList = false,
}: Props): React.ReactElement<Props> => {
  const [searchSort, setSearchSort] = useState<Option["value"]>(value)
  const handleChange = (value: Option["value"]): void => {
    setSearchSort(value)
    onChange(value)
  }
  return (
    <SortDropdownWrapper isRecentList={isRecentList}>
      {!isRecentList && (<><Trans id="label_sort_by" message="Sort by"/>:</>) }
      <Dropdown
        selectedOption={searchSort}
        options={options}
        onChange={handleChange}
      />
    </SortDropdownWrapper>
  )
}

export default SortDropdown
